import _en from "./en-US.json";
import _nb from "./nb-NO.json";

export const en = { ..._en };
export const nb = { ..._nb };
